module.exports = __webpack_public_path__ + "img/functional2-img6.0a56f7fc.png";